import ApplicationController from '../application_controller'
import Rails from '@rails/ujs'
import { useDebounce } from 'stimulus-use'

export default class extends ApplicationController {
  static targets = [
    'listContainer', 'tagTemplate', 'tagsContainer', 'loadingIndicator',
    'searchInput'
  ]

  static values = { selected: Array }

  static debounces = ['retrieveResults']

  doConnect() {
    useDebounce(this, { wait: 1200 })
    this.regulationStore = new Set(this.selectedValue || [])
    this.init()
  }

  init() {
    this.regulationStore.forEach(element => {
      this.addTag(element)
    })
  }

  clearAll() {
    this.regulationStore = new Set()
    this.tagsContainerTarget.innerHTML = ''
  }

  addRegulation(value) {
    if (!this.regulationStore.has(value)) {
      this.regulationStore.add(value)
      this.addTag(value)
    }
  }

  removeRegulation(value) {
    if (this.regulationStore.has(value)) {
      this.regulationStore.delete(value)
    }
  }

  retrieveResults(event) {
    const queryString = event?.target?.value || ''
    this.loadingIndicatorTarget.classList.remove('hidden')
    this.listContainerTarget.classList.add('hidden')
    const locations = this.getFilterFormInputsValue().search_attributes.locations

    Rails.ajax({
      type: 'POST',
      url: '/omni_searches/autocompletes',
      dataType: 'html',
      data: $.param({
        query_string: queryString, locations: locations
      }),
      success: (response) => {
        this.listContainerTarget.innerHTML = response.body.innerHTML
        this.loadingIndicatorTarget.classList.add('hidden')
        this.listContainerTarget.classList.remove('hidden')
      },
      error: (e) => {
        this.listContainerTarget.innerHTML = 'An error occurred. Please refresh the page and try again.'
      }
    })
  }

  selectOption(event) {
    const regulation = event.currentTarget.dataset.value
    this.addRegulation(regulation)
    this.dispatchCustomEvent('option-selected', {})
  }

  removeTag(event) {
    const itemToDelete = event.currentTarget.parentNode // TODO - Find parent dynamically because this adds dependency on the markup structure of the icon component
    const regulation = itemToDelete.getAttribute('data-value')
    this.removeRegulation(regulation)
    itemToDelete.parentNode.removeChild(itemToDelete)
    this.dispatchCustomEvent('option-selected', {})
  }

  addTag(value) {
    const tagTemplate = this.tagTemplateTarget.firstElementChild.cloneNode(true)
    tagTemplate.setAttribute('data-value', value)
    tagTemplate.querySelector('*[data-tag]').innerHTML = value
    tagTemplate.querySelector('*[data-value]').setAttribute('data-value', value)
    const inputTemplate = tagTemplate.querySelector('input')
    inputTemplate.setAttribute('value', value)
    inputTemplate.setAttribute('name', inputTemplate.getAttribute('data-name'))
    this.tagsContainerTarget.appendChild(tagTemplate)
  }

  getFilterFormInputsValue() {
    return $.deparam($(this.searchInputTarget.form).serialize())
  }
}
